import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CategoryListRes;
export const CategoryListTodo = createAsyncThunk('CategoryList', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'categroy_list',
            data: {
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id')
            },
            headers: { "Content-Type": "application/json" },

        })
        return CategoryListRes = res.data

    } catch (error) {
        return CategoryListRes = error.response.data
    }
});

const CategoryListSlice = createSlice({
    name: 'CategoryList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(CategoryListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(CategoryListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default CategoryListSlice.reducer; 